module.exports = __webpack_public_path__ + "img/duplicate-scan-label.0adaa6c4.svg";